import StandaloneAchievement from 'models/achievement/StandaloneAchievement';

import AchievementBaseService from 'services/achievement/AchievementBaseService';

export default class StandaloneAchievementService extends AchievementBaseService {
	toModel(achievement) {
		return new StandaloneAchievement(achievement);
	}
}
